<template>
  <v-form ref="form">
    <v-container grid-list-md class="px-3">
      <v-layout wrap>
        <v-flex xs12 v-if="!enrolmentDone">
          <page-header-title :title="$t('fe.enrolment.enrol') + ': ' + page_title" class="enr-title mt-4 mb-4"></page-header-title>

          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex lg8 md8 sm12 xs12 v-if="!enrolmentDone">
                <v-expansion-panels v-model="clpsEnrDetailExpand" class="cstm-filter elevation-0" ref="attendees_expansion_panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header hide-actions>
                      <span>
                        <v-icon dark>{{ clpsEnrDetailIcon }}</v-icon>
                        <span v-if="enrolment.vat">
                          {{
                            "(" +
                            enrolment.vat +
                            ") " +
                            (enrolment.name ||
                              (organisations &&
                                organisations.length &&
                                organisations.find((i) => i.id == enrolment.selected_company_id).name))
                          }}
                        </span>
                        <span v-else>{{ " " + $t("fe.enrolment.company_information") }}</span>
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="elevation-1">
                      <v-layout wrap>
                        <v-flex lg5 md6 sm9 xs12>
                          <v-select
                            name="o_name"
                            v-model="enrolment.selected_company_id"
                            :items="organisations"
                            item-text="name"
                            item-value="id"
                            :label="$t('fe.enrolment.o_name')"
                            class="required-field multiple-companies"
                            v-validate="'required'"
                            autocomplete="new-password"
                            :error-messages="errors.collect('o_name')"
                            :disabled="fields_disabled || Boolean(autofill_data && autofill_data.company_vat)"
                            @change="updateOrgVatMultiple"
                            v-if="autofill_data && autofill_data.companies.length > 1"
                          >
                            <template v-slot:append-item>
                              <span class="d-none">&nbsp;</span>
                            </template>
                            <template v-slot:no-data>
                              {{ $t("organisations.org_does_not_exist") }}
                            </template>
                            <template v-slot:item="{ item }"> {{ item.name }} ({{ item.vat }}) </template>
                          </v-select>

                          <v-combobox
                            name="o_name"
                            v-model="enrolment.name"
                            :items="organisations"
                            item-text="text"
                            item-value="vat"
                            :label="$t('fe.enrolment.o_name')"
                            class="required-field"
                            v-validate="'required'"
                            autocomplete="new-password"
                            :error-messages="errors.collect('o_name')"
                            :disabled="
                              fields_disabled ||
                              Boolean(autofill_data && autofill_data.company_vat) ||
                              Boolean(!autofill_data && course.company_id)
                            "
                            :search-input.sync="orgNameSearch"
                            @change="updateOrgVat"
                            clearable
                            v-else
                          >
                            <template v-slot:append>
                              <span class="d-none">&nbsp;</span>
                            </template>
                            <template v-slot:append-item>
                              <span class="d-none">&nbsp;</span>
                            </template>
                            <template v-slot:no-data>
                              {{ $t("organisations.org_does_not_exist") }}
                            </template>
                            <template v-slot:item="{ item }"> {{ item.text }} ({{ item.vat }}) </template>
                          </v-combobox>
                        </v-flex>
                        <v-flex lg3 md3 sm3 xs12>
                          <v-text-field
                            name="o_vat"
                            v-model="enrolment.vat"
                            class="required-field"
                            v-validate="'required|max:9'"
                            :label="$t('fe.enrolment.o_vat')"
                            :error-messages="errors.collect('o_vat')"
                            :disabled="
                              fields_disabled ||
                              Boolean(autofill_data && autofill_data.company_vat) ||
                              Boolean(autofill_data && autofill_data.companies.length > 1) ||
                              Boolean(!autofill_data && course.company_id)
                            "
                            @keypress="$keyDown_IntOnly($event)"
                            :hint="$t('global.helptext_vat')"
                            persistent-hint
                            :append-outer-icon="'sync'"
                            @click:append-outer="searchOrgByVat(enrolment.vat)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_first_name"
                            class="required-field"
                            v-model="enrolment.first_name"
                            v-validate="'max:50|required'"
                            :label="$t('fe.enrolment.o_first_name')"
                            :error-messages="errors.collect('o_first_name')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_last_name"
                            class="required-field"
                            v-model="enrolment.last_name"
                            v-validate="'max:50|required'"
                            :label="$t('fe.enrolment.o_last_name')"
                            :error-messages="errors.collect('o_last_name')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_email"
                            class="required-field"
                            v-model="enrolment.email"
                            v-validate="'email|max:255|required'"
                            :label="$t('fe.enrolment.o_email')"
                            :error-messages="errors.collect('o_email')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_reference"
                            v-model="enrolment.reference"
                            v-validate="'max:50'"
                            :label="$t('fe.enrolment.o_reference')"
                            :error-messages="errors.collect('o_reference')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            name="enrolment.comments"
                            v-model="enrolment.comments"
                            rows="2"
                            auto-grow
                            :label="$t('fe.enrolment.comment')"
                            :error-messages="errors.collect('enrolment.comments')"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>

                      <v-subheader class="pl-0"
                        ><b>{{ $t("fe.enrolment.visiting_address") }}</b></v-subheader
                      >

                      <v-layout wrap>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_v_address_street"
                            v-model="enrolment.v_street"
                            v-validate="'max:50'"
                            :label="$t('fe.enrolment.o_address_street')"
                            :error-messages="errors.collect('o_v_address_street')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg2 md2 sm4 xs12>
                          <v-text-field
                            name="o_v_address_zip"
                            v-model="enrolment.v_zip"
                            v-validate="'max:6'"
                            :label="$t('fe.enrolment.o_address_zip')"
                            :error-messages="errors.collect('o_v_address_zip')"
                            :disabled="fields_disabled"
                            @blur="visitingZipCodeChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm8 xs12>
                          <v-text-field
                            name="o_v_address_city"
                            v-model="enrolment.v_city"
                            v-validate="'max:50'"
                            :label="$t('fe.enrolment.o_address_city')"
                            :error-messages="errors.collect('o_v_address_city')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg2 md2 sm12 xs12>
                          <v-autocomplete
                            name="o_v_address_country"
                            v-model="enrolment.v_country"
                            :items="this.$dd_countries()"
                            item-text="text"
                            item-value="key"
                            :label="$t('fe.enrolment.o_address_country')"
                            autocomplete="new-password"
                            :error-messages="errors.collect('o_v_address_country')"
                            :disabled="fields_disabled"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <v-subheader class="pl-0"
                        ><b>{{ $t("fe.enrolment.invoice_address") }}</b></v-subheader
                      >

                      <v-layout wrap>
                        <v-flex lg4 md4 sm6 xs12>
                          <v-text-field
                            name="o_i_address_street"
                            v-model="enrolment.i_street"
                            v-validate="'max:50'"
                            :label="$t('fe.enrolment.o_address_street')"
                            :error-messages="errors.collect('o_i_address_street')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg2 md2 sm4 xs12>
                          <v-text-field
                            name="o_v_address_zip"
                            v-model="enrolment.i_zip"
                            v-validate="'max:6'"
                            :label="$t('fe.enrolment.o_address_zip')"
                            :error-messages="errors.collect('o_i_address_zip')"
                            :disabled="fields_disabled"
                            @blur="invoiceZipCodeChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm8 xs12>
                          <v-text-field
                            name="o_i_address_city"
                            v-model="enrolment.i_city"
                            v-validate="'max:50'"
                            :label="$t('fe.enrolment.o_address_city')"
                            :error-messages="errors.collect('o_i_address_city')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg2 md2 sm6 xs12>
                          <v-autocomplete
                            name="o_v_address_country"
                            v-model="enrolment.i_country"
                            :items="this.$dd_countries()"
                            item-text="text"
                            item-value="key"
                            :label="$t('fe.enrolment.o_address_country')"
                            autocomplete="new-password"
                            :error-messages="errors.collect('o_i_address_country')"
                            :disabled="fields_disabled"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-text-field
                            name="invoice_email"
                            v-model="enrolment.invoice_email"
                            v-validate="'email'"
                            :label="$t('fe.enrolment.invoice_email')"
                            :error-messages="errors.collect('invoice_email')"
                            :disabled="fields_disabled"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels v-model="clpsEnrParExpand" class="cstm-filter mt-4 elevation-0" ref="attendees_expansion_panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header hide-actions>
                      <span>
                        <v-icon dark>{{ clpsEnrParIcon }}</v-icon>
                        {{ $t("fe.enrolment.participants") }}
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="elevation-1">
                      <v-container grid-list-md class="pa-0">
                        <v-layout row wrap>
                          <v-flex lg2 md3 sm6 xs12>
                            <v-text-field
                              name="no_of_participants"
                              type="number"
                              v-model="no_of_participants"
                              class="required-field"
                              v-validate="'required'"
                              :label="$t('fe.enrolment.no_of_participants')"
                              :error-messages="errors.collect('no_of_participants')"
                              :disabled="fields_disabled || modal"
                              autocomplete="new-password"
                              min="1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 md4 sm6 xs12 v-if="course.allow_reservation"
                            ><v-checkbox v-model="participants_unknown" class="d-inline-flex ml-3" hide-details></v-checkbox>
                            {{ $t("fe.enrolment.participants_unknown") }}</v-flex
                          >
                          <v-flex lg4 md4 sm6 xs12 v-if="!participants_unknown">
                            <v-checkbox v-model="same_choices_for_all" class="d-inline-flex ml-3" hide-details></v-checkbox>
                            {{ $t("fe.enrolment.same_choices_for_all") }}
                          </v-flex>

                          <v-divider class="mb-0" v-if="!participants_unknown"></v-divider>

                          <v-flex xs12 v-if="!participants_unknown">
                            <v-data-table
                              class="enr_table"
                              :headers="enr_headers"
                              :items="dummyArray"
                              item-key="index"
                              :expanded.sync="expanded"
                              show-expand
                              :hide-default-header="true"
                              :hide-default-footer="true"
                              disable-pagination
                              :must-sort="true"
                            >
                              <template v-slot:item.number="{ item }">
                                <v-chip small dark color="primary">{{ item.index + 1 }}</v-chip>
                              </template>
                              <template v-slot:item.first_name="{ item }">
                                <v-text-field
                                  :name="$t('fe.enrolment.p_first_name') + ' [' + (item.index + 1) + ']'"
                                  v-model="participants.first_name[item.index]"
                                  class="required-field"
                                  v-validate="'required|max:50'"
                                  :label="$t('fe.enrolment.p_first_name')"
                                  :error-messages="
                                    $validator.errors.collect($t('fe.enrolment.p_first_name') + ' [' + (item.index + 1) + ']')
                                  "
                                  :disabled="fields_disabled"
                                ></v-text-field>
                              </template>
                              <template v-slot:item.last_name="{ item }">
                                <v-text-field
                                  :name="$t('fe.enrolment.p_last_name') + ' [' + (item.index + 1) + ']'"
                                  v-model="participants.last_name[item.index]"
                                  class="required-field"
                                  v-validate="'required|max:50'"
                                  :label="$t('fe.enrolment.p_last_name')"
                                  :error-messages="
                                    $validator.errors.collect($t('fe.enrolment.p_last_name') + ' [' + (item.index + 1) + ']')
                                  "
                                  :disabled="fields_disabled"
                                ></v-text-field>
                              </template>
                              <template v-slot:item.email="{ item }">
                                <v-text-field
                                  :name="$t('fe.enrolment.p_email') + ' [' + (item.index + 1) + ']'"
                                  v-model="participants.email[item.index]"
                                  class="required-field"
                                  v-validate="'required|email|max:255'"
                                  :label="$t('fe.enrolment.p_email')"
                                  :error-messages="$validator.errors.collect($t('fe.enrolment.p_email') + ' [' + (item.index + 1) + ']')"
                                  :disabled="fields_disabled"
                                ></v-text-field>
                              </template>
                              <template v-slot:item.mobile="{ item }">
                                <vue-tel-input-vuetify
                                  v-validate="'required|max:50'"
                                  :label="$t('fe.enrolment.p_mobile')"
                                  class="required-field"
                                  v-model="participants.mobile[item.index]"
                                  @input="
                                    (formattedNumber, { number, valid, country }) => {
                                      participants.mobile[item.index] = number.significant || formattedNumber
                                      participants.mobile_code[item.index] = country.dialCode || null
                                    }
                                  "
                                  placeholder=""
                                  :name="$t('fe.enrolment.p_mobile') + ' [' + (item.index + 1) + ']'"
                                  :error-messages="$validator.errors.collect($t('fe.enrolment.p_mobile') + ' [' + (item.index + 1) + ']')"
                                  defaultCountry="NO"
                                  :disabled="fields_disabled"
                                ></vue-tel-input-vuetify>
                              </template>
                              <template v-slot:item.date_of_birth="{ item }">
                                <v-dialog ref="dialog" v-model="dob_date_menu[item.index]" persistent width="290px">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      :name="$t('fe.enrolment.p_date_of_birth') + ' [' + (item.index + 1) + ']'"
                                      :label="$t('fe.enrolment.p_date_of_birth')"
                                      v-validate="'validDate'"
                                      v-model="participants.date_of_birth_format[item.index]"
                                      :error-messages="
                                        $validator.errors.collect($t('fe.enrolment.p_date_of_birth') + ' [' + (item.index + 1) + ']')
                                      "
                                      append-icon="event"
                                      @click:append="$set(dob_date_menu, item.index, true)"
                                      :hint="'Format: ' + DATE_FORMAT"
                                      :disabled="fields_disabled"
                                      @change="dobTextChange(item.index)"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    v-model="participants.date_of_birth[item.index]"
                                    first-day-of-week="1"
                                    :disabled="fields_disabled"
                                    @change="dobChange(item.index)"
                                    :locale="$locale_bcp47(locale)"
                                    :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      class="darken-2"
                                      @click="
                                        $set(dob_date_menu, item.index, false)
                                        dobChange(item.index)
                                      "
                                      >{{ $t("global.ok") }}</v-btn
                                    >
                                  </v-date-picker>
                                </v-dialog>
                              </template>
                              <template v-slot:expanded-item="{ item }">
                                <td colspan="7" style="background: #fff">
                                  <v-container grid-list-md class="pa-2 my-3" elevation-2>
                                    <v-layout wrap>
                                      <v-flex sm12 md6 lg6>
                                        <p class="font-weight-black sidebar-price-title">
                                          {{ $t("fe.enrolment.include") }}
                                        </p>
                                        <div v-for="(mt, idx) in moduletemplates_included" :key="mt.id">
                                          <p class="font-weight-black mb-0">{{ mt.name }}</p>

                                          <div v-if="mt.moduleoptions.length > 0">
                                            <v-radio-group
                                              dense
                                              v-model="selectedIncluded[item.index][mt.id].selected_option"
                                              @change="moduleoptionChangeInc(item.index)"
                                              class="mt-0 radio-full-width"
                                              v-validate="'required'"
                                              :name="'mo.' + mt.id"
                                            >
                                              <v-simple-table dense class="enr_details_table">
                                                <tr v-if="!mt.mandatory">
                                                  <td scope="row">
                                                    <v-radio
                                                      dense
                                                      :label="$t('global.none_select')"
                                                      value="none"
                                                      :disabled="fields_disabled"
                                                    ></v-radio>
                                                  </td>
                                                  <td scope="row" class="text-end" width="20%"></td>
                                                </tr>

                                                <template v-for="mo in mt.moduleoptions">
                                                  <tr :key="'mo-' + mo.id">
                                                    <td scope="row">
                                                      <v-radio
                                                        dense
                                                        :label="
                                                          mo.name +
                                                          (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')
                                                        "
                                                        :value="mo.id"
                                                        :disabled="fields_disabled"
                                                      ></v-radio>
                                                      <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                                                    </td>
                                                    <td scope="row" class="text-end va-text-top price" width="20%">
                                                      <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                                                    </td>
                                                  </tr>

                                                  <template
                                                    v-if="
                                                      moduleoptioncoursetypesinc[mo.id].length > 0 &&
                                                      selectedIncluded[item.index][mt.id].selected_option == mo.id
                                                    "
                                                  >
                                                    <tr :key="'mo-mtname-' + mo.id">
                                                      <td class="pl-3">
                                                        <p class="mb-0">
                                                          <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                                                        </p>
                                                      </td>
                                                    </tr>
                                                    <tr v-for="moct in moduleoptioncoursetypesinc[mo.id]" :key="moct.id">
                                                      <td scope="row" class="pl-3">
                                                        <v-checkbox
                                                          :name="'moct.' + mt.id"
                                                          dense
                                                          :label="moct.name"
                                                          v-model="selectedIncluded[item.index][mt.id].selected_coursetypes"
                                                          :value="moct.id"
                                                          class="chk-moduleoption mt-0"
                                                          @change="moduleoptionChangeInc(item.index)"
                                                          v-validate="'required'"
                                                          :disabled="fields_disabled"
                                                        >
                                                        </v-checkbox>
                                                        <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                                      </td>
                                                      <td scope="row" class="text-end va-text-top price" width="20%">
                                                        <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                                      </td>
                                                    </tr>
                                                  </template>
                                                </template>
                                                <tr v-if="errors.first('moct.' + mt.id)">
                                                  <td>
                                                    <div class="v-messages theme--light error--text mb-2">
                                                      <div class="v-messages__wrapper">
                                                        <div class="v-messages__message">
                                                          {{ errors.first("moct." + mt.id) }}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </v-simple-table>
                                            </v-radio-group>
                                            <div class="v-messages theme--light error--text mb-2">
                                              <div class="v-messages__wrapper">
                                                <div class="v-messages__message">
                                                  {{ errors.first("mo." + mt.id) }}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <v-divider class="mb-3"></v-divider>

                                        <p class="font-weight-black sidebar-price-title">
                                          {{ $t("fe.enrolment.additionals") }}
                                        </p>

                                        <div v-for="(mt, idx) in moduletemplates_not_included" :key="mt.id">
                                          <p class="font-weight-black mb-0">{{ mt.name }}</p>

                                          <v-radio-group
                                            dense
                                            v-model="selectedAdditionals[item.index][mt.id].selected_option"
                                            @change="moduleoptionChange(item.index)"
                                            class="mt-0 radio-full-width"
                                            v-validate="'required'"
                                            :name="'mo.' + mt.id"
                                          >
                                            <v-simple-table dense class="enr_details_table">
                                              <tr v-if="!mt.mandatory">
                                                <td scope="row">
                                                  <v-radio
                                                    dense
                                                    :label="$t('global.none_select')"
                                                    value="none"
                                                    :disabled="fields_disabled"
                                                  ></v-radio>
                                                </td>
                                                <td scope="row" class="text-end" width="20%"></td>
                                              </tr>
                                              <template v-for="mo in mt.moduleoptions">
                                                <tr :key="'mo-' + mo.id">
                                                  <td scope="row">
                                                    <v-radio
                                                      dense
                                                      :label="
                                                        mo.name +
                                                        (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')
                                                      "
                                                      :value="mo.id"
                                                      :disabled="fields_disabled"
                                                    ></v-radio>
                                                    <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                                                  </td>
                                                  <td scope="row" class="text-end va-text-top price" width="20%">
                                                    <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                                                  </td>
                                                </tr>
                                                <template
                                                  v-if="
                                                    moduleoptioncoursetypes[mo.id].length > 0 &&
                                                    selectedAdditionals[item.index][mt.id].selected_option == mo.id
                                                  "
                                                >
                                                  <tr :key="'mo-mtname-' + mo.id">
                                                    <td class="pl-3">
                                                      <p class="mb-0">
                                                        <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                                                      </p>
                                                    </td>
                                                  </tr>
                                                  <tr v-for="moct in moduleoptioncoursetypes[mo.id]" :key="moct.id">
                                                    <td scope="row">
                                                      <v-checkbox
                                                        :name="'moct.' + mt.id"
                                                        dense
                                                        :label="moct.name"
                                                        v-model="selectedAdditionals[item.index][mt.id].selected_coursetypes"
                                                        :value="moct.id"
                                                        class="chk-moduleoption mt-0"
                                                        @change="moduleoptionChange(item.index)"
                                                        v-validate="'required'"
                                                        :disabled="fields_disabled"
                                                      >
                                                      </v-checkbox>
                                                      <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                                    </td>
                                                    <td scope="row" class="text-end va-text-top price" width="20%">
                                                      <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                                    </td>
                                                  </tr>
                                                </template>
                                              </template>
                                              <tr v-if="errors.first('moct.' + mt.id)">
                                                <td>
                                                  <div class="v-messages theme--light error--text mb-2">
                                                    <div class="v-messages__wrapper">
                                                      <div class="v-messages__message">
                                                        {{ errors.first("moct." + mt.id) }}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </v-simple-table>
                                          </v-radio-group>
                                          <div class="v-messages theme--light error--text">
                                            <div class="v-messages__wrapper">
                                              <div class="v-messages__message">
                                                {{ errors.first("mo." + mt.id) }}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </v-flex>
                                      <v-flex sm12 md6 lg6>
                                        <v-simple-table dense class="enr_details_table">
                                          <tr>
                                            <td scope="row">
                                              <p class="font-weight-black price">
                                                {{ $t("fe.enrolment.price") }}
                                              </p>
                                            </td>
                                            <td scope="row" class="text-end price" width="20%">
                                              <span>{{ price[item.index] + " " + CURRENCY }}</span>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td scope="row">
                                              <p class="font-weight-black price">
                                                {{ $t("fe.enrolment.price_additional") }}
                                              </p>
                                            </td>
                                            <td scope="row" class="text-end price" width="20%">
                                              <span>{{ price_additional[item.index] + " " + CURRENCY }}</span>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td scope="row">
                                              <p class="font-weight-black price">
                                                {{ $t("fe.enrolment.price_total") }}
                                              </p>
                                            </td>
                                            <td scope="row" class="text-end price" width="20%">
                                              <span>{{ price_total[item.index] + " " + CURRENCY }}</span>
                                            </td>
                                          </tr>
                                        </v-simple-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                          <v-flex xs12 v-else>
                            <v-textarea v-model="reservation_comment" rows="4" auto-grow :label="$t('fe.enrolment.comment')"></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>

              <v-flex lg4 md4 sm12 xs12 v-if="!enrolmentDone">
                <v-card>
                  <v-card-text class="pa-4">
                    <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.include") }}</p>
                    <div v-for="(mt, index) in moduletemplates_included" :key="mt.id">
                      <p class="font-weight-black mb-1">{{ mt.name }}</p>

                      <div v-if="mt.moduleoptions.length > 0">
                        <v-simple-table dense>
                          <template v-for="mo in mt.moduleoptions">
                            <tr :key="'mo-' + mo.id">
                              <td scope="row" width="75%">
                                {{ mo.name + (mo.hours > 0 ? " (" + mo.hours + " " + $t("moduleoptions.hours") + ")" : "") }}
                                <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                              </td>
                              <td scope="row">
                                <span class="font-weight-black mr-5"> {{ enrCountSelectedModuleOption(selectedIncluded, mo.id) }} x </span>
                              </td>
                              <td scope="row" class="text-end va-text-top price" width="15%">
                                <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                              </td>
                            </tr>
                            <tr :key="'moct-' + mo.id" v-if="moduleoptioncoursetypesinc[mo.id].length > 0">
                              <td colspan="3">
                                <v-simple-table dense>
                                  <tr v-for="moct in moduleoptioncoursetypesinc[mo.id]" :key="moct.id">
                                    <td scope="row" width="75%">
                                      <div class="pl-4">
                                        {{ moct.name }}
                                        <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                      </div>
                                    </td>
                                    <td scope="row">
                                      <span class="font-weight-black mr-5">
                                        {{ enrCountSelectedModuleOptionCourseType(selectedIncluded, moct.id) }}
                                        x
                                      </span>
                                    </td>
                                    <td scope="row" class="text-end va-text-top price" width="15%">
                                      <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                    </td>
                                  </tr>
                                </v-simple-table>
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>

                    <v-divider class="mb-3"></v-divider>

                    <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.additionals") }}</p>

                    <div v-for="(mt, index) in moduletemplates_not_included" :key="mt.id">
                      <p class="font-weight-black mb-1">{{ mt.name }}</p>

                      <v-simple-table dense>
                        <template v-for="mo in mt.moduleoptions">
                          <tr :key="'mo-' + mo.id">
                            <td scope="row" width="75%">
                              {{ mo.name + (mo.hours > 0 ? " (" + mo.hours + " " + $t("moduleoptions.hours") + ")" : "") }}
                              <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                            </td>
                            <td scope="row">
                              <span class="font-weight-black mr-5"> {{ enrCountSelectedModuleOption(selectedAdditionals, mo.id) }} x </span>
                            </td>
                            <td scope="row" class="text-end va-text-top price" width="15%">
                              <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                            </td>
                          </tr>
                          <tr :key="'moct-' + mo.id" v-if="moduleoptioncoursetypes[mo.id].length > 0">
                            <td colspan="3">
                              <v-simple-table dense>
                                <tr v-for="moct in moduleoptioncoursetypes[mo.id]" :key="moct.id">
                                  <td scope="row" width="75%">
                                    <div class="pl-4">
                                      {{ moct.name }}
                                      <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                    </div>
                                  </td>
                                  <td scope="row">
                                    <span class="font-weight-black mr-5">
                                      {{ enrCountSelectedModuleOptionCourseType(selectedAdditionals, moct.id) }}
                                      x
                                    </span>
                                  </td>
                                  <td scope="row" class="text-end va-text-top price" width="15%">
                                    <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                  </td>
                                </tr>
                              </v-simple-table>
                            </td>
                          </tr>
                        </template>
                      </v-simple-table>
                    </div>

                    <v-divider class="mb-3"></v-divider>

                    <v-simple-table dense class="mt-3">
                      <tr>
                        <td scope="row" width="75%">
                          <p class="font-weight-black price">
                            {{ $t("fe.enrolment.price") }}
                          </p>
                        </td>
                        <td scope="row">
                          <span v-if="no_of_participants > 1" class="font-weight-black mr-5">{{ no_of_participants }} x</span>
                        </td>
                        <td scope="row" class="text-end price" width="15%">
                          <span>{{ course.price + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row" colspan="2">
                          <p class="font-weight-black price">
                            {{ $t("fe.enrolment.price_additional") }}
                          </p>
                        </td>
                        <td scope="row" class="text-end price">
                          <span>{{ all_price_additional + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row" colspan="2">
                          <p class="font-weight-black price">{{ $t("fe.enrolment.price_total") }}</p>
                        </td>
                        <td scope="row" class="text-end price">
                          <span>{{ all_price_total + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex xs12 v-if="!enrolmentDone">
          <v-divider class="my-2"></v-divider>
          <v-card class="bottom-card">
            <v-card-text class="pa-1">
              <v-container grid-list-md class="pa-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12>
                        <vue-recaptcha ref="recaptcha" class="captcha d-none" :sitekey="RECAPTCHA_KEY"> </vue-recaptcha>
                      </v-flex>

                      <v-flex xs12 md8 class="text-center">
                        <p class="d-inline-flex va-top privacy-line mt-2">
                          <v-checkbox
                            name="coursetype"
                            dense
                            v-model="accept_privacy"
                            v-validate="'required'"
                            class="d-inline-flex mt-0 pt-0"
                            hide-details
                          >
                          </v-checkbox>

                          {{ $t("fe.enrolment.privacy_consent_to") }}
                          <a @click="show_policy = !show_policy" class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                        </p>

                        <br />

                        <v-btn
                          class="button_text--text cstm-v-btn darken-2"
                          color="primary"
                          large
                          @click="validateEnrol"
                          :disabled="!validForm || !accept_privacy"
                        >
                          {{ pay_with_klarna ? $t("fe.enrolment.pay_and_enrol") : $t("fe.enrolment.submit") }}
                        </v-btn>
                        <action-button type="back" @click="back" large color="error" v-if="!modal" />
                        <action-button type="cancel" @click="$emit('return_modal_form', 'cancel')" large color="error" v-if="modal" />
                      </v-flex>
                      <v-flex xs12 md4 class="text-center"></v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="enrolmentDone">
          <v-card class="mx-auto mt-10" max-width="50%" color="success" dark>
            <v-card-title class="headline">
              <span v-if="!computedParticipantUnknown">
                {{
                  course && course.send_email_notification
                    ? $t("fe.enrolment.enrolment_success")
                    : $t("fe.enrolment.enrolment_success_noemailsms")
                }}
              </span>

              <span v-else>
                {{ $t("fe.enrolment.enrolment_success_reservation") }}
              </span>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <privacyPolicy :show="show_policy" :locale="locale" @callback_privacy_cancel="show_policy = false" />

    <klarna-payment
      :show="klarna_show"
      :type="klarna_type"
      :order_data="klarna_order_data"
      :enrolment_ids="klarna_enrolment_ids"
      @klarna_success="klarnaSuccess"
      @klarna_failed="klarnaFailed"
      @klarna_cancel="klarnaClear"
    />
  </v-form>
</template>

<script>
import _ from "lodash"
import { VueRecaptcha } from "@/mixins/vue-recaptcha"
import privacyPolicy from "../partials/Privacy"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "EnrolmentOrganisation",

  props: ["locale", "cid", "autofill_data", "modal"],

  components: {
    privacyPolicy,
    VueRecaptcha,
    VueTelInputVuetify,
    "klarna-payment": () => import("@/mixins/components/klarnaPayment")
  },

  data() {
    return {
      page_title: "",
      coursetemplate: {},
      course: {
        id: null,
        coursetype: {
          fullname: ""
        },
        price: 0
      },

      enr_headers: [
        { text: "", value: "data-table-expand", width: "10px" },
        { text: "", value: "number", width: "10px" },
        { text: "", value: "first_name", sortable: false },
        { text: "", value: "last_name", sortable: false },
        { text: "", value: "email", sortable: false },
        { text: "", value: "mobile", sortable: false },
        { text: "", value: "date_of_birth", sortable: false }
      ],

      readMoreActivated: false,
      readMoreActivatedShort: false,

      enrolment: {
        name: ""
      },
      enrolmentDone: false,

      expanded: [{ index: 0 }],
      dummyArray: [],

      moduletemplates: [],
      moduletemplates_included: [],
      moduletemplates_not_included: [],

      moduleoptioncoursetypes: {},
      moduleoptioncoursetypesinc: {},

      selectedAdditionals: {},
      selectedIncluded: {},

      totalSelectedAdditionals: {},
      totalselectedIncluded: {},

      price: {},
      price_additional: {},
      price_total: {},

      all_price: 0,
      all_price_additional: 0,
      all_price_total: 0,

      available_enrolment: 0,
      fields_disabled: false,
      accept_privacy: false,
      show_policy: false,

      organisations: [],
      orgNameSearch: null,

      recaptchaData: null,

      integrations: [],
      integration_klarna: null,
      pay_with_klarna: false,

      klarna_show: false,
      klarna_type: null,
      klarna_order_id: null,
      klarna_token: null,
      klarna_payment_methods: [],
      klarna_order_data: {},
      klarna_enrolment_ids: [],
      klarna_order_lines: [],

      clpsEnrDetailExpand: 0,
      clpsEnrDetailIcon: "mdi-collapse-all-outline",
      clpsEnrParExpand: 0,
      clpsEnrParIcon: "mdi-collapse-all-outline",

      participants: {
        index: [],
        id: [],
        first_name: [],
        last_name: [],
        email: [],
        mobile: [],
        mobile_code: [],
        date_of_birth: [],
        date_of_birth_format: []
      },
      active_tab: 0, // personal
      dob_date_menu: [],
      no_of_participants: 0,
      same_choices_for_all: false,
      participants_unknown: false,
      reservation_comment: null,
      dictionary: {
        attributes: {
          o_course_id: this.$t("fe.enrolment.o_course_id"),
          o_vat: this.$t("fe.enrolment.o_vat"),
          o_reference: this.$t("fe.enrolment.o_reference"),
          o_name: this.$t("fe.enrolment.o_name"),
          o_first_name: this.$t("fe.enrolment.o_first_name"),
          o_last_name: this.$t("fe.enrolment.o_last_name"),
          o_email: this.$t("fe.enrolment.o_email"),
          o_custom_number: this.$t("fe.enrolment.o_customer_number"),
          o_v_address_street: this.$t("fe.enrolment.o_address_street"),
          o_v_address_city: this.$t("fe.enrolment.o_address_city"),
          o_v_address_state: this.$t("fe.enrolment.o_address_state"),
          o_v_address_zip: this.$t("fe.enrolment.o_address_zip"),
          o_v_address_country: this.$t("fe.enrolment.o_address_country"),
          o_i_address_street: this.$t("fe.enrolment.o_address_street"),
          o_i_address_city: this.$t("fe.enrolment.o_address_city"),
          o_i_address_state: this.$t("fe.enrolment.o_address_state"),
          o_i_address_zip: this.$t("fe.enrolment.o_address_zip"),
          o_i_address_country: this.$t("fe.enrolment.o_address_country"),
          invoice_email: this.$t("fe.enrolment.invoice_email"),
          no_of_participants: this.$t("fe.enrolment.no_of_participants"),

          p_first_name: this.$t("fe.enrolment.p_first_name"),
          p_last_name: this.$t("fe.enrolment.p_last_name"),
          p_email: this.$t("fe.enrolment.p_email"),
          p_mobile: this.$t("fe.enrolment.p_mobile"),
          p_date_of_birth: this.$t("fe.enrolment.p_date_of_birth"),

          coursetype: this.$t("moduleoptioncoursetypes.coursetype_id")
        }
      }
    }
  },

  computed: {
    loggedinuser: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    computedCourseStartDate() {
      return this.course.start_date ? this.moment.utc(this.course.start_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseStartTime() {
      return this.course.start_time ? this.moment.utc(this.course.start_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    computedCourseEndDate() {
      return this.course.end_date ? this.moment.utc(this.course.end_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseEndTime() {
      return this.course.end_time ? this.moment.utc(this.course.end_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    computedParticipantUnknown() {
      return this.participants_unknown
    },
    validForm() {
      let bool = true

      if (!this.enrolment.name) bool = false
      if (!this.enrolment.vat) bool = false
      if (!this.enrolment.first_name) bool = false
      if (!this.enrolment.last_name) bool = false
      if (!this.enrolment.email) bool = false

      if (!this.participants_unknown) {
        for (let i = 0; i <= this.no_of_participants - 1; i++) {
          if (!this.participants.first_name[i]) bool = false
          if (!this.participants.last_name[i]) bool = false
          if (!this.participants.email[i]) bool = false
          if (!this.participants.mobile[i]) bool = false
        }
      }

      return bool
    }
  },

  watch: {
    orgNameSearch: {
      handler: _.debounce(function (search) {
        this.searchOrgVatByName(search)
      }, 300)
    },
    same_choices_for_all: {
      handler: function (val) {
        if (val && this.no_of_participants >= 2) {
          for (let idx = 1; idx <= this.no_of_participants - 1; idx++) {
            this.copyEnrolmentChoices(idx)
          }
        }
      }
    },
    participants_unknown: {
      handler: function (val) {
        for (let i = 0; i <= this.no_of_participants - 1; i++) {
          this.preNoOfParticipants(i)
        }
      }
    },
    no_of_participants: {
      handler: function (val, prevVal) {
        this.participants.id.length = val
        this.participants.first_name.length = val
        this.participants.last_name.length = val
        this.participants.email.length = val
        this.participants.mobile.length = val
        this.participants.mobile_code.length = val
        this.participants.date_of_birth.length = val
        this.participants.date_of_birth_format.length = val
        this.expanded.length = val

        if (val) {
          if (Number(val) > Number(prevVal)) {
            if (prevVal == "") {
              prevVal = 0
            }

            for (let i = prevVal; i <= val - 1; i++) {
              this.preNoOfParticipants(i)
            }
          } else {
            for (let i = val; i <= prevVal - 1; i++) {
              delete this.selectedAdditionals[i]
              delete this.selectedIncluded[i]
              delete this.price[i]
              delete this.price_additional[i]
              delete this.price_total[i]
              this.recomputeTotal()
            }
          }

          this.dummyArray = Array.from({ length: val }, (item, index) => ({ index: index }))
        } else {
          this.selectedAdditionals = {}
          this.selectedIncluded = {}
          this.price = {}
          this.price_additional = {}
          this.price_total = {}
          this.dummyArray = []
          this.recomputeTotal()
        }
      }
    },
    clpsEnrDetailExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrDetailIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEnrParExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrParIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    if (this.autofill_data && this.autofill_data.participants) {
      this.no_of_participants = this.autofill_data.participants.length
    } else {
      this.no_of_participants = 1
    }

    axios.get(this.API_URL + "open/organisation/my").then((res) => {
      let data = res.data.data
      this.$store.dispatch("frontend/setOrganisation", data)

      this.$setTenantInAxiosHeader(data.tenant_id)
      this.enrolment.i_country = this.$getDefaultDropdown(this.$dd_countries())
      this.enrolment.v_country = this.$getDefaultDropdown(this.$dd_countries())

      this.integrations = data.integrations
      if (this.integrations) {
        this.integration_klarna = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_KLARNA)
      }

      if (this.autofill_data && this.autofill_data.companies.length > 1) {
        this.organisations = this.autofill_data.companies
      }

      if (this.cid) {
        axios.get(this.API_URL + "open/course/uuid/" + this.cid).then((res) => {
          this.course = res.data.data
          let available_enrolment = this.course.num_places - this.course.num_enrolled

          this.pay_with_klarna = Boolean(
            this.integration_klarna &&
              this.course.klarna_checkout &&
              (this.course.klarna_checkout_type == 2 || this.course.klarna_checkout_type == 3)
          )

          // Check if course is_published is checked
          // Check if enrolment_due_date is still valid
          // Check if available sits is still available
          if (
            (this.course && !this.course.allow_overbook && Boolean(available_enrolment <= 0)) ||
            (this.course && this.moment(this.course.enrolment_due_date).diff(this.moment(), "days") < 0)
          ) {
            if (this.autofill_data) {
              this.initCourse()
            } else {
              this.$router.push("/f/" + this.locale + "/enrolment/organisation/interest")
              this.fields_disabled = true
            }
          } else {
            this.initCourse()
          }
        })
      }

      if (this.loggedinuser && this.loggedinuser.id) {
        this.enrolment.first_name = this.loggedinuser.person.first_name
        this.enrolment.last_name = this.loggedinuser.person.last_name
        this.enrolment.email = this.loggedinuser.email
      }

      if (this.autofill_data && this.autofill_data.company_vat) {
        this.enrolment.vat = this.autofill_data.company_vat

        axios.post(this.API_URL + "enrolment/organisation/vat-exist/" + this.enrolment.vat).then((res) => {
          let status = res.data.status
          let record = res.data.record
          if (status == "exist" && record) {
            this.$set(this.enrolment, "name", record.name)
            this.$set(this.enrolment, "vat", record.vat)
          }
        })
      }
    })
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  methods: {
    copyEnrolmentChoices(idx) {
      this.$set(this.selectedAdditionals, idx, JSON.parse(JSON.stringify(this.selectedAdditionals[0])))
      this.$set(this.selectedIncluded, idx, JSON.parse(JSON.stringify(this.selectedIncluded[0])))
      this.$set(this.price, idx, JSON.parse(JSON.stringify(this.price[0])))
      this.$set(this.price_additional, idx, JSON.parse(JSON.stringify(this.price_additional[0])))
      this.$set(this.price_total, idx, JSON.parse(JSON.stringify(this.price_total[0])))

      this.recompute(idx)
    },
    initCourse(id) {
      let vm = this

      if (this.course) {
        let course = this.course
        let title = []

        if (course.start_date) title.push(this.moment.utc(course.start_date).format(this.DATE_FORMAT))
        if (course.address.city) title.push(course.address.city)
        if (course.name) title.push(course.name)

        if (title.length > 0) {
          this.page_title = title.join(", ")
        }

        if (course.company_id && !this.autofill_data) {
          this.enrolment.name = course.company.name || null
          this.enrolment.vat = course.company.vat || null
          this.enrolment.v_street = course.company.visiting_street || null
          this.enrolment.v_city = course.company.visiting_city || null
          this.enrolment.v_zip = course.company.visiting_zip || null
          this.enrolment.v_country = course.company.visiting_country || null

          this.enrolment.i_street = course.company.invoice_street || null
          this.enrolment.i_city = course.company.invoice_city || null
          this.enrolment.i_zip = course.company.invoice_zip || null
          this.enrolment.i_country = course.company.invoice_country || null
        }

        this.enrolment.course_id = course.id
        this.available_enrolment = course.num_places - course.num_enrolled

        this.moduletemplates = this.course.moduletemplates

        // Filter "Included" module templates
        this.moduletemplates_included = this.moduletemplates.filter((i) => i.is_included == 1 && !i.hide_in_enrolment)
        this.moduletemplates_included.forEach(function (mt) {
          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)
          mt.moduleoptions.forEach(function (mo) {
            vm.moduleoptioncoursetypesinc[mo.id] = []
            vm.moduleoptioncoursetypesinc[mo.id] = mo.coursetypes
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
          vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
        })

        // Filter "Not Included" module templates
        this.moduletemplates_not_included = this.moduletemplates.filter((i) => i.is_included != 1 && !i.hide_in_enrolment)
        this.moduletemplates_not_included.forEach(function (mt) {
          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)
          mt.moduleoptions.forEach(function (mo) {
            vm.moduleoptioncoursetypes[mo.id] = []
            vm.moduleoptioncoursetypes[mo.id] = mo.coursetypes
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
          vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
        })

        // Reset enrolment selections
        vm.selectedIncluded = {}
        vm.selectedAdditionals = {}
        for (let i = 1; i <= vm.no_of_participants; i++) {
          let idx = i - 1
          vm.preNoOfParticipants(idx)
        }

        if (this.autofill_data && this.autofill_data.participants.length > 0) {
          this.autofill_data.participants.forEach((item, index) => {
            this.$set(this.participants.id, index, item.id)
            this.$set(this.participants.first_name, index, item.first_name)
            this.$set(this.participants.last_name, index, item.last_name)
            this.$set(this.participants.email, index, item.email)
            this.$set(this.participants.mobile, index, item.mobile)
            this.$set(this.participants.date_of_birth, index, this.$dateFormatSetter(item.date_of_birth))
            this.$set(this.participants.date_of_birth_format, index, this.$dateFormatGetter(item.date_of_birth))
          })
        }

        // Reinitialize validator dictionary
        vm.$validator.localize(vm.locale, vm.dictionary)
      }
    },
    preNoOfParticipants(idx) {
      let vm = this

      vm.$set(vm.selectedIncluded, idx, {})

      this.moduletemplates_included.forEach(function (mt) {
        vm.$set(vm.selectedIncluded[idx], mt.id, {})
        vm.$set(vm.selectedIncluded[idx][mt.id], "selected_coursetypes", [])

        if (mt.moduleoptions.length == 1) {
          vm.$set(vm.selectedIncluded[idx][mt.id], "selected_option", mt.mandatory ? mt.moduleoptions[0].id : "none")
        } else {
          vm.$set(vm.selectedIncluded[idx][mt.id], "selected_option", mt.mandatory ? "" : "none")
        }
      })

      vm.$set(vm.selectedAdditionals, idx, {})

      this.moduletemplates_not_included.forEach(function (mt) {
        vm.$set(vm.selectedAdditionals[idx], mt.id, {})
        vm.$set(vm.selectedAdditionals[idx][mt.id], "selected_coursetypes", [])

        if (mt.moduleoptions.length == 1) {
          vm.$set(vm.selectedAdditionals[idx][mt.id], "selected_option", mt.mandatory ? mt.moduleoptions[0].id : "none")
        } else {
          vm.$set(vm.selectedAdditionals[idx][mt.id], "selected_option", mt.mandatory ? "" : "none")
        }
      })

      vm.price[idx] = 0
      vm.price_additional[idx] = 0
      vm.price_total[idx] = 0

      vm.recompute(idx)
    },
    recompute(idx) {
      let vm = this

      vm.price[idx] = Boolean(_.has(vm.course, "id")) ? vm.course.price : 0
      vm.price_additional[idx] = 0
      vm.price_total[idx] = 0

      _.forEach(vm.selectedIncluded[idx], function (obj, key) {
        let mt = vm.moduletemplates_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional[idx] += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypesinc[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional[idx] += moct.price
            }
          })
        }
      })

      _.forEach(vm.selectedAdditionals[idx], function (obj, key) {
        let mt = vm.moduletemplates_not_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional[idx] += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypes[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional[idx] += moct.price
            }
          })
        }
      })

      vm.price[idx] = vm.price[idx]
      vm.price_additional[idx] = vm.price_additional[idx]
      vm.price_total[idx] = vm.price[idx] + vm.price_additional[idx]

      this.recomputeTotal()
    },

    recomputeTotal() {
      // compute for price total
      let vm = this

      let course_price = Boolean(_.has(vm.course, "id")) ? vm.course.price : 0

      vm.all_price = 0
      vm.all_price_additional = 0
      vm.all_price_total = 0

      vm.klarna_order_lines = []

      vm.klarna_order_lines.push({
        name: this.course.name,
        quantity: Number(vm.no_of_participants),
        unit_price: course_price * 100,
        tax_rate: 0,
        total_amount: course_price * 100 * vm.no_of_participants,
        total_tax_amount: 0
      })

      // INCLUDED
      _.forEach(vm.moduletemplates_included, function (mt) {
        if (mt.moduleoptions.length > 0) {
          _.forEach(mt.moduleoptions, function (mo) {
            // count module options
            let mo_count = vm.enrCountSelectedModuleOption(vm.selectedIncluded, mo.id)
            if (mo_count > 0) {
              vm.klarna_order_lines.push({
                name: mo.name,
                quantity: mo_count,
                unit_price: mo.price * 100,
                tax_rate: 0,
                total_amount: mo.price * 100 * mo_count,
                total_tax_amount: 0
              })
            }

            // count module option - course types
            if (vm.moduleoptioncoursetypesinc[mo.id] && vm.moduleoptioncoursetypesinc[mo.id].length > 0) {
              _.forEach(vm.moduleoptioncoursetypesinc[mo.id], function (moct) {
                let moct_count = vm.enrCountSelectedModuleOptionCourseType(vm.selectedIncluded, moct.id)
                if (moct_count > 0) {
                  vm.klarna_order_lines.push({
                    name: moct.name,
                    quantity: moct_count,
                    unit_price: moct.price * 100,
                    tax_rate: 0,
                    total_amount: moct.price * 100 * moct_count,
                    total_tax_amount: 0
                  })
                }
              })
            }
          })
        }
      })

      // ADDITIONALS
      _.forEach(vm.moduletemplates_not_included, function (mt) {
        if (mt.moduleoptions.length > 0) {
          _.forEach(mt.moduleoptions, function (mo) {
            // count module options
            let mo_count = vm.enrCountSelectedModuleOption(vm.selectedAdditionals, mo.id)
            if (mo_count > 0) {
              vm.klarna_order_lines.push({
                name: mo.name,
                quantity: mo_count,
                unit_price: mo.price * 100,
                tax_rate: 0,
                total_amount: mo.price * 100 * mo_count,
                total_tax_amount: 0
              })
            }

            // count module option - course types
            if (vm.moduleoptioncoursetypes[mo.id] && vm.moduleoptioncoursetypes[mo.id].length > 0) {
              _.forEach(vm.moduleoptioncoursetypes[mo.id], function (moct) {
                let moct_count = vm.enrCountSelectedModuleOptionCourseType(vm.selectedAdditionals, moct.id)
                if (moct_count > 0) {
                  vm.klarna_order_lines.push({
                    name: moct.name,
                    quantity: moct_count,
                    unit_price: moct.price * 100,
                    tax_rate: 0,
                    total_amount: moct.price * 100 * moct_count,
                    total_tax_amount: 0
                  })
                }
              })
            }
          })
        }
      })

      _.forEach(vm.price, function (val) {
        vm.all_price += val
      })

      _.forEach(vm.price_additional, function (val) {
        vm.all_price_additional += val
      })

      _.forEach(vm.price_total, function (val) {
        vm.all_price_total += val
      })
    },

    moduleoptionChange(idx) {
      let vm = this

      _.forEach(vm.selectedAdditionals[idx], function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypes[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      // uncheck "same for all" checkbox
      if (idx >= 1 && this.same_choices_for_all) {
        this.same_choices_for_all = false
      } else if (idx == 0 && this.same_choices_for_all) {
        for (let i = 1; i <= this.no_of_participants - 1; i++) {
          this.copyEnrolmentChoices(i)
        }
      }

      vm.recompute(idx)
    },

    moduleoptionChangeInc(idx) {
      let vm = this

      _.forEach(vm.selectedIncluded[idx], function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypesinc[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      // uncheck "same for all" checkbox
      if (idx >= 1 && this.same_choices_for_all) {
        this.same_choices_for_all = false
      } else if (idx == 0 && this.same_choices_for_all) {
        for (let i = 1; i <= this.no_of_participants - 1; i++) {
          this.copyEnrolmentChoices(i)
        }
      }

      vm.recompute(idx)
    },

    validateEnrol() {
      this.$validator.validate()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.course && !this.course.allow_overbook && Boolean(this.available_enrolment <= 0)) {
            this.$awn.confirm(
              this.$t("fe.enrolment.course_full_register"),
              () => {
                this.enrol()
              },
              () => {
                return
              }
            )
          } else {
            this.enrol()
          }
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },

    enrol() {
      let vm = this

      let vdata = []

      for (let i = 0; i <= this.no_of_participants - 1; i++) {
        if (this.participants.first_name[i] && this.participants.last_name[i] && this.participants.email[i]) {
          vdata[i] = {
            course_id: this.enrolment.course_id,
            first_name: this.participants.first_name[i],
            last_name: this.participants.last_name[i],
            email: this.participants.email[i],
            date_of_birth: this.participants.date_of_birth[i],
            date_of_birth_format: this.participants.date_of_birth_format[i]
          }
        }

        this.participants.mobile[i] = this.$formatPhoneNumber(this.participants.mobile[i], this.participants.mobile_code[i])
      }

      axios
        .post(this.API_URL + "open/enrolment/validate", {
          data: JSON.stringify(vdata)
        })
        .then((res) => {
          let status = res.data.status
          let duplicates = res.data.duplicates

          if (res.data.status == "not-valid") {
            if (duplicates.length > 0) {
              let names = []

              duplicates.forEach((item, index) => {
                names[index] = item.first_name + " " + item.last_name
              })

              vm.$awn.alert(
                vm.$t("fe.enrolment.enrolment_duplicate", {
                  names: names.join(", ")
                })
              )
            }
          } else {
            /*let name = this.enrolment.name
            if(this.autofill_data && this.autofill_data.companies.length > 1) {
              let org = this.organisations.find((i) => i.id == this.enrolment.selected_company_id)
              if (org) {
                name = org.name
              }
            }*/

            axios
              .post(this.API_URL + "open/enrolment", {
                site: process.env.VUE_APP_DOMAIN,
                subdomain: vm.SUBDOMAIN,
                course_id: this.enrolment.course_id,
                reference: this.enrolment.reference,
                vat: this.enrolment.vat,
                name: this.enrolment.name,
                first_name: this.enrolment.first_name,
                last_name: this.enrolment.last_name,
                email: this.enrolment.email,
                v_street: this.enrolment.v_street,
                v_city: this.enrolment.v_city,
                v_state: "",
                v_zip: this.enrolment.v_zip,
                v_country: this.enrolment.v_country,
                i_street: this.enrolment.i_street,
                i_city: this.enrolment.i_city,
                i_state: "",
                i_zip: this.enrolment.i_zip,
                i_country: this.enrolment.i_country,
                invoice_email: this.enrolment.invoice_email,
                comments: this.enrolment.comments,
                created_by: null,
                participants: this.participants,
                type: "organisation",
                mode: "enrolment",
                price: this.all_price,
                price_additional: this.all_price_additional,
                price_total: this.all_price_total,
                additionals: JSON.stringify(this.selectedAdditionals),
                additionals_inc: JSON.stringify(this.selectedIncluded),
                course_full: Boolean(this.available_enrolment <= 0) && !this.course.allow_overbook,
                pay_with_klarna: this.pay_with_klarna,
                participants_unknown: this.participants_unknown,
                reservation_comment: this.reservation_comment
              })
              .then((res) => {
                if (typeof res.data.errors !== "undefined") {
                } else {
                  let ids = res.data.ids || null
                  let data_ids = res.data.data_ids || null

                  if (ids) {
                    if (this.pay_with_klarna) {
                      this.klarnaCheckout(ids)
                    } else {
                      vm.participants = {
                        ids: [],
                        first_name: [],
                        last_name: [],
                        email: [],
                        mobile: [],
                        date_of_birth: [],
                        date_of_birth_format: []
                      }

                      let participants_unknown = this.participants_unknown
                      vm.$refs.form.reset()
                      this.participants_unknown = participants_unknown

                      vm.no_of_participants = 1
                      vm.accept_privacy = false
                      vm.errors.items = []

                      if (this.modal && this.autofill_data) {
                        vm.$emit("return_modal_form", data_ids)
                      } else {
                        vm.enrolmentDone = true
                        window.scrollTo(0, 0)
                      }
                    }
                  } else {
                    vm.$swal({
                      text: vm.$t("fe.enrolment.enrolment_error"),
                      icon: "error",
                      closeOnClickOutside: false,
                      closeOnEsc: false
                    })
                  }
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch((err) => console.log(err))
    },

    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.enrolment, "name", companyname || null)
            this.$set(this.enrolment, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.enrolment, "name", null)
            vm.$set(vm.enrolment, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           id: item.id,
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.enrolment, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.enrolment, "vat", this.organisations.length ? this.organisations[0].vat : null)
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function (error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },

    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text: companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         id: item.id,
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      if (this.enrolment.name && typeof this.enrolment.name === "object") {
        let org = this.organisations.find((i) => i.key == this.enrolment.name.key)
        if (org) {
          this.$set(this.enrolment, "name", org.text || null)
          this.$set(this.enrolment, "vat", org.vat || null)
          return
        }

        // let org = this.organisations.find((i) => i.vat == this.enrolment.name.vat)
        // if (org) {
        //   let promise = this.$api1881SearchID(org.id)
        //   promise
        //     .then((res) => {
        //       let data = res.data
        //       if (data && data.contacts) {
        //         data = data.contacts[0]

        //         this.$set(this.enrolment, "v_street", (data.geography.address.street || '') + " " + (data.geography.address.houseNumber || ''))
        //         this.$set(this.enrolment, "v_zip", data.geography.address.postCode || '')
        //         this.$set(this.enrolment, "v_city", data.geography.address.postArea || '')
        //         this.$set(this.enrolment, "v_state", data.geography.county || '')
        //       }
        //     })
        //     .catch(function (error) {
        //       console.log(error)
        //     })

        //   this.$set(this.enrolment, "name", org.text)
        //   this.$set(this.enrolment, "vat", org.vat)
        //   return
        // }
      }

      this.$set(this.enrolment, "name", this.enrolment.name || null)
      this.$set(this.enrolment, "vat", null)

      this.$set(this.enrolment, "v_street", null)
      this.$set(this.enrolment, "v_zip", null)
      this.$set(this.enrolment, "v_city", null)
      this.$set(this.enrolment, "v_state", null)
    },

    updateOrgVatMultiple() {
      let org = this.organisations.find((i) => i.id == this.enrolment.selected_company_id)

      if (org) {
        this.enrolment.vat = org.vat
        this.enrolment.name = org.name
      }
    },

    dobTextChange(index) {
      this.$set(this.participants.date_of_birth, index, this.$dateFormatSetter(this.participants.date_of_birth_format[index]))
    },

    dobChange(index) {
      this.$set(this.participants.date_of_birth_format, index, this.$dateFormatGetter(this.participants.date_of_birth[index]))
      this.$validator.validate(this.$t("fe.enrolment.p_date_of_birth") + " [" + index + "]", this.participants.date_of_birth_format[index])
    },

    visitingZipCodeChange() {
      this.$getCity(this.enrolment.v_zip, this.enrolment.v_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "v_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "v_city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.enrolment.i_zip, this.enrolment.i_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "i_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "i_city", null)
        })
    },
    enrCountSelectedModuleOption(data, id) {
      let vm = this
      let count = 0

      _.forEach(data, function (obj, key) {
        _.forEach(obj, function (obj2, key2) {
          if (obj2.selected_option == id) {
            count++
          }
        })
      })

      return count
    },
    enrCountSelectedModuleOptionCourseType(data, id) {
      let vm = this
      let count = 0

      _.forEach(data, function (obj, key) {
        _.forEach(obj, function (obj2, key2) {
          count += obj2.selected_coursetypes.filter((a) => a == id).length
        })
      })

      return count
    },

    back() {
      if (this.course) {
        this.$router.push("/f/" + this.locale + "/enrolment/template/" + this.course.coursetemplate.uuid + "/course/" + this.course.uuid)
      }
    },

    klarnaCheckout(ids) {
      // CHECKOUT API
      let order_data = {
        purchase_country: "NO",
        purchase_currency: "NOK",
        locale: "en-US",
        order_amount: this.all_price_total * 100,
        order_tax_amount: 0,
        order_lines: this.klarna_order_lines,
        billing_address: {
          organization_name: this.enrolment.name,
          given_name: this.enrolment.first_name,
          family_name: this.enrolment.last_name,
          email: this.enrolment.invoice_email || this.enrolment.email,
          street_address: this.enrolment.i_street,
          city: this.enrolment.i_city,
          postal_code: this.enrolment.i_zip,
          country: this.countryAlpha2(this.enrolment.i_country),
          reference: this.enrolment.reference
        },
        customer: {
          type: "organization",
          vat_id: this.enrolment.vat,
          organization_registration_id: this.enrolment.vat
        },
        merchant_urls: {
          terms: "https://www.example.com/terms.html",
          checkout: "https://www.example.com/checkout.html",
          confirmation: `https://${window.location.hostname}/f/no/klarna/checkout/order-confirmation/{checkout.order.id}`,
          push: "https://www.example.com/api/push"
        }
      }

      this.klarna_type = "checkout"
      this.klarna_order_data = order_data
      this.klarna_enrolment_ids = ids
      this.klarna_show = true
    },
    klarnaSuccess(data) {
      this.$awn.success("Order ID: " + data.order_id)
      this.klarnaClear()
    },
    klarnaFailed(data) {
      let error = data.error || this.$t("auth.invalidrequest_t")
      this.$awn.alert(error)
      this.paymentClear()
    },
    klarnaClear() {
      this.klarna_order_data = {}
      this.klarna_show = false
    }
  }
}
</script>

<style>
.privacy-line {
  margin-top: 22px;
}
.privacy-link {
  font-size: 14px;
}
.chk-moduleoption {
  height: 30px;
  padding-top: 3px;
  margin-top: 0;
}
.v-messages {
  min-height: 0 !important;
}
.bottom-card {
  box-shadow: none !important;
}
p.price,
.price span {
  font-size: 14px !important;
}
.enr_table tbody tr td {
  padding: 0 10px 0 5px !important;
}
.enr_table .v-data-table__mobile-row__cell {
  width: 100% !important;
}
.enr_table .enr_details_table tr {
  background: #fff !important;
}
</style>
